import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Placeholder from "@/v2-ui/Placeholder"
import ErrorMessage from "@/v2-ui/ErrorMessage"
import BaseTabs from "@/v2-ui/tabs"
import { useTabsState } from "./tabs.context"

export type TabsListProps = ComponentProps<typeof BaseTabs.List>

function TabsList(props: TabsListProps) {
  const { className, children, ...baseTabsListProps } = props
  const state = useTabsState()

  return (
    <>
      <BaseTabs.List
        className={cn("ui-tabs-list", className)}
        {...baseTabsListProps}
      >
        {children}
        {state?.isLoading && (
          <svg className="ui-tabs-list-loading-bar">
            <rect
              className="ui-tabs-list-loading-bar-indicator"
              pathLength={100}
              width="100%"
              height="100%"
            />
          </svg>
        )}
      </BaseTabs.List>

      {state?.error && (
        <ErrorMessage className="ui-tabs-list-error" error={state.error} />
      )}

      {state?.isEmpty && !state?.isLoading && (
        <Placeholder className="ui-tabs-list-empty">
          {state.emptyLabel}
        </Placeholder>
      )}
    </>
  )
}

export default TabsList
